import React from 'react';
import { BookOpen } from 'lucide-react';

const LoadingScreen = () => {
  return (
    <div className="fixed inset-0 bg-white z-50 flex flex-col items-center justify-center">
      {/* Logo che pulsa */}
      <div className="relative">
        <div className="absolute inset-0 bg-indigo-100 rounded-full animate-ping opacity-75"></div>
        <div className="relative bg-white p-4 rounded-full shadow-xl border border-slate-100">
            <BookOpen size={48} className="text-indigo-600 animate-pulse" />
        </div>
      </div>
      
      <p className="mt-6 text-sm font-bold text-slate-400 uppercase tracking-widest animate-pulse">
        Caricamento...
      </p>
    </div>
  );
};

export default LoadingScreen;